var _ellipse;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInnerCircle = function SvgInnerCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 251 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.714,
    cy: 107.909,
    rx: 137.928,
    ry: 89.493,
    transform: "rotate(-34.353 125.714 107.909)",
    stroke: "#26272B",
    strokeLinecap: "round",
    strokeDasharray: "10 14"
  })));
};

export default SvgInnerCircle;